import { render, staticRenderFns } from "./ModalItemIframe.vue?vue&type=template&id=dca9ac2a&scoped=true&"
import script from "./ModalItemIframe.vue?vue&type=script&lang=ts&"
export * from "./ModalItemIframe.vue?vue&type=script&lang=ts&"
import style0 from "./ModalItemIframe.vue?vue&type=style&index=0&id=dca9ac2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca9ac2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dca9ac2a')) {
      api.createRecord('dca9ac2a', component.options)
    } else {
      api.reload('dca9ac2a', component.options)
    }
    module.hot.accept("./ModalItemIframe.vue?vue&type=template&id=dca9ac2a&scoped=true&", function () {
      api.rerender('dca9ac2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalItemIframe.vue"
export default component.exports